import { render } from "./NavigationIcon.vue?vue&type=template&id=a3ae8514&scoped=true"
import script from "./NavigationIcon.vue?vue&type=script&lang=js"
export * from "./NavigationIcon.vue?vue&type=script&lang=js"

import "./NavigationIcon.vue?vue&type=style&index=0&id=a3ae8514&scoped=true&lang=css"

import exportComponent from "D:\\projects\\mitool\\MITOOL\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a3ae8514"]])

export default __exports__